import { BillboardGeo } from 'api/interfaces/Billboard'
import { defaultTransformFn, platformApi } from 'api/rtkQueryApi/platform/platformApi'

export interface BillboardQueryParams {
  zipCodes: string[]
}

const billboardApiTags = platformApi.enhanceEndpoints({
  addTagTypes: ['BillboardLocations']
})

export const billboardApi = billboardApiTags.injectEndpoints({
  endpoints: build => ({
    getBillboardsByZipCodes: build.query<BillboardGeo[], BillboardQueryParams>({
      query: ({ zipCodes }) => {
        const zipCodesParam = zipCodes.map(zip => `zipCode=${encodeURIComponent(zip)}`).join('&')
        return {
          url: `billboardLocations/billboardsByZipcode?${zipCodesParam}`,
          method: 'GET',
          isContext: true,
          isAgency: false
        }
      },
      transformResponse: defaultTransformFn,
      providesTags: (result, error, { zipCodes }) => [
        {
          type: 'BillboardLocations',
          id: [...zipCodes].sort().join(',')
        }
      ]
    })
  }),
  overrideExisting: false
})

export const { useGetBillboardsByZipCodesQuery, useLazyGetBillboardsByZipCodesQuery } = billboardApi
